<template>
  <v-dialog
    v-model="dialog"
    hide-overlay
    :max-width="dialogMaxWidth"
    :max-height="dialogMaxHeight"
  >
    <v-card>
      <v-card-title> <span class="headline">{{ $t('userPictureProfiles.crop.title') }}</span> </v-card-title>
      <v-card-text>
        <vue-cropper
          ref="cropper"
          :guides="true"
          :view-mode="0"
          drag-mode="move"
          :auto-crop-area="0.5"
          :min-container-width="256"
          :min-container-height="256"
          :background="true"
          :rotatable="true"
          :src="imgSrc"
          :aspect-ratio="1"
          alt="Source Image"
          :modal="true"
          :img-style="{ width: '256px', height: '256px' }"
          :center="false"
          :highlight="true"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn icon @click="rotate('r')"><v-icon>mdi-rotate-right</v-icon></v-btn>
        <v-btn icon @click="rotate('l')"><v-icon>mdi-rotate-left</v-icon></v-btn>

        <v-spacer></v-spacer>
        <v-btn @click="$emit('stop-cropping')" text
          >{{ $t('userPictureProfiles.btn.noCrop') }}</v-btn
        >
        <v-btn color="primary" @click="cropImage" text
          >{{ $t('userPictureProfiles.btn.crop') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import events from 'Store/events'

export default {
  props: {
    dialogMaxWidth: { default: '600px' },
    dialogMaxHeight: { default: '0.8vh' },
    dialog: { default: false },
    file: { default: null }
  },
  components: {
    VueCropper
  },
  watch: {
    file: {
      immediate: true,
      handler (newFile, oldFile) {
        if (newFile) {
          this.setImage()
        }
      }
    }
  },
  data () {
    return {
      imgSrc: '',
      cropImg: null,
      filename: null,
      cropBlob: null
    }
  },
  computed: {
    croppedFile () {
      return new File([this.croppedBlob], this.file.name, { type: this.file.type })
    }
  },
  methods: {
    setImage () {
      this.filename = this.file.name

      if (!this.file.type.includes('image/')) {
        events.pubError(this.$t('userPictureProfiles.errors.unvalidateImage'))
        this.$emit('stop-cropping')
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader()

        reader.onload = event => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
          this.$emit('update:dataUrl', this.imgSrc)
        }

        reader.readAsDataURL(this.file)
      } else {
        events.pubError(this.$t('userPictureProfiles.errors.unsupportedFileReader'))
        this.$emit('stop-cropping')
      }
    },
    cropImage () {
      this.$refs.cropper
        .getCroppedCanvas()
        .toBlob(
          blob => {
            this.cropImg = URL.createObjectURL(blob)
            this.croppedBlob = blob
            this.$emit('update:objectUrl', this.cropImg)
            this.$emit('cropped-image', this.croppedFile)
            this.$emit('stop-cropping')
          },
          'image/jpeg',
          0.95
        )
    },
    rotate (dir) {
      if (dir === 'r') {
        this.$refs.cropper.rotate(90)
      } else {
        this.$refs.cropper.rotate(-90)
      }
    },
    flip (vert) {
      const { scaleX, scaleY, rotate } = this.$refs.cropper.getData()
      // when image is rotated, direction must be flipped
      if (rotate === 90 || rotate === 270) {
        vert = !vert
      }
      if (vert) {
        this.$refs.cropper.scale(scaleX, -1 * scaleY)
      } else {
        this.$refs.cropper.scale(-1 * scaleX, scaleY)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-icon.v-icon.v-icon--link {
  padding: 0 10px;
}
</style>
